/**
 * Met à jour les attributs de commande "Genre" et "_VisuelEmail" à chaque
 * modification du panier.
 *
 * Le metafield custom.genre n'étant pas exposé par l'API AJAX (/cart.js),
 * on délègue le calcul à la section Liquid `cart-genre` (récupérée via la
 * Section Rendering API), puis on écrit le résultat dans cart.attributes
 * via /cart/update.js. Ces cart attributes remontent nativement sur la commande.
 */
(function () {
  const ATTRIBUTE_KEY = 'Genre';
  const VISUEL_KEY = '_VisuelEmail';
  const SECTION_ID = 'cart-genre';

  let lastWrittenGenre = null;
  let inFlight = false;

  async function computeGenreFromLiquid() {
    const url = `${window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'}?sections=${SECTION_ID}`;
    const response = await fetch(url);
    if (!response.ok) return null;
    const data = await response.json();
    const html = data[SECTION_ID];
    if (typeof html !== 'string') return null;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.getElementById('cart-genre-data');
    if (!node) return null;
    return {
      genre: node.getAttribute('data-genre') || '',
      visuel: node.getAttribute('data-visuel') || '',
    };
  }

  async function syncCartGenre() {
    if (inFlight) return;
    inFlight = true;
    try {
      const data = await computeGenreFromLiquid();
      if (data === null) return;

      const signature = `${data.genre}|${data.visuel}`;
      if (signature === lastWrittenGenre) return;

      await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { [ATTRIBUTE_KEY]: data.genre, [VISUEL_KEY]: data.visuel },
        }),
      });
      lastWrittenGenre = signature;
    } catch (e) {
      // Silencieux : ne doit jamais bloquer le parcours d'achat.
    } finally {
      inFlight = false;
    }
  }

  // À chaque modification du panier (ajout PDP / quick-add / drawer / page panier).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartGenre);
  }

  // Synchronisation initiale (panier déjà rempli au chargement).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartGenre);
  } else {
    syncCartGenre();
  }
})();
